var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._b({attrs:{"options":_vm.options,"placeholder":"请选择级别"},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'el-cascader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }